import { Activity } from '@user/features/Activity/typings'
import { put, isAPIError } from '@user/store/services/crud'
import { toast } from '@sales-center/components'
import { getActivityUrl } from '../constants'

export async function updateActivity(
  activity: Activity,
): Promise<Activity | undefined> {
  if (activity.ownerId === 'unassigned') {
    activity.ownerId = null
  }
  const response = await put(getActivityUrl, activity)
  const result = await response.json()

  if (!response.ok) {
    if (isAPIError(result)) {
      toast.error(result.Message)
    } else {
      toast.error('Failed to update Activity')
    }
    return undefined
  } else {
    toast.success('Activity updated')
  }

  return result
}
